import {createAction, createGetter, createMutation, CustomStore, mutate, on, select} from '@softline/core';
import {Aktivitaet} from '../types/aktivitaet';
import {lastValueFrom} from 'rxjs';
import {PruefprotokollService} from '../services/pruefprotokoll.service';
import {Pruefprotokoll} from '../types/pruefprotokoll';
import {Scan} from '@softline/application';

export interface PruefprotokollErstellenState {
  lagerplatz: object | null;
  aktivitaet: Aktivitaet | null;
  bemerkung: string | null;
}

const mutations = {
  setLagerplatz: createMutation<PruefprotokollErstellenState, object | null>('produktions/pruefprotokoll/erstellen/setLager'),
  setAktivitaet: createMutation<PruefprotokollErstellenState, Aktivitaet | null>('produktions/pruefprotokoll/erstellen/setAktivitaet'),
  setBemerkung: createMutation<PruefprotokollErstellenState, string | null>('produktions/pruefprotokoll/erstellen/setBemerkung'),
  clear: createMutation<PruefprotokollErstellenState, void>('produktions/pruefprotokoll/erstellen/clear')
};

const getters = {
  state: createGetter<PruefprotokollErstellenState, PruefprotokollErstellenState>('produktions/pruefprotokoll/erstellen/getState')
};

const actions = {
  aufzeichnen: createAction<PruefprotokollErstellenState, PruefprotokollErstellenState, Pruefprotokoll>('produktions/pruefprotokoll/erstellen/erstellen'),
  validateLagerplatzScan: createAction<PruefprotokollErstellenState, Scan, object>('produktions/pruefprotokoll/erstellen/validateLagerplatzScan'),
}

export const PruefprotokollErstellenStore: CustomStore<PruefprotokollErstellenState, typeof mutations, typeof getters, typeof actions> = {
  mutations,
  getters,
  actions,
  feature: {
    initialState: {
      aktivitaet: null,
      lagerplatz: null,
      bemerkung: null,
    },
    getters: [
      select(getters.state, ({ state }) => state)
    ],
    mutations: [
      mutate(mutations.setLagerplatz, ({ state, params }) => ({ ...state, lagerplatz: params })),
      mutate(mutations.setAktivitaet, ({ state, params }) => ({ ...state, aktivitaet: params })),
      mutate(mutations.setBemerkung, ({ state, params }) => ({ ...state, bemerkung: params })),
      mutate(mutations.clear, () => ({ lagerplatz: null, aktivitaet: null, bemerkung: null })),
    ],
    actions: [
      on(actions.aufzeichnen, async ({ featureName, commit, injector, params }) => {
        const service = injector.get(PruefprotokollService);

        if (!params.aktivitaet)
          return;

        const result = await lastValueFrom(
          service.aufzeichnen({
            aktivitaetBean: params.aktivitaet,
            kommentar: params.bemerkung ?? '',
            lagerPlatzBean: params.lagerplatz as never,
            zeitstempel: new Date().toISOString()
          })
        );

        commit(featureName, mutations.clear);
        return result;
      }),

      on(actions.validateLagerplatzScan, async ({ featureName, commit, injector, params }) => {
        const service = injector.get(PruefprotokollService);
        const result = await lastValueFrom(service.getLagerplatz(params.data));
        commit(featureName, mutations.setLagerplatz, result);
        return result;
      })
    ]
  }
}
